// Angular
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
// RxJS
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { Router } from '@angular/router';
import { UserService } from '../../../../core/_services/user.service';
import * as JWT from 'jwt-decode';

// import { debug } from 'util';

/**
 * More information there => https://medium.com/@MetonymyQT/angular-http-interceptors-what-are-they-and-how-to-use-them-52e060321088
 */
@Injectable()
export class InterceptService implements HttpInterceptor {

	constructor(private router: Router, private _userService: UserService) { }

	// intercept request and add token
	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {

		let token = localStorage.getItem(environment.authTokenKey);
if(token)
{
			let jwt = JWT(token);
		    let userId = jwt['UserID'];



			request = request.clone({
				setHeaders: {
					Authorization: `Bearer ${token}`,
					'X-UserId': userId // ← aqui você adiciona o cabeçalho personalizado
				}
			});
		}
	

		return next.handle(request).pipe(
			tap(
				event => {
					if (event instanceof HttpResponse) {
						// console.log('all looks good');
						// http response status code
						// console.log(event.status);
					}
				},
				error => {
				

					if (this.router.url.indexOf('auth/login') < 0 && error.status === 401) {

					//	console.error("aquiiiiiiiii333333333");
						//corrigir
						this._userService.logout();
					}

				}
			),
			catchError(error=>
				{
					throw error;
				})
		);
	}
}
